(() => {
  const initStickyBuy = (root) => {
    if (!root || root.dataset.blazeStickyReady === 'true') return;

    const bar = root.querySelector('[data-blaze-sticky-buy]');
    if (!bar) return;

    root.dataset.blazeStickyReady = 'true';

    const targets = Array.from(
      document.querySelectorAll(
        '[data-blaze-buy-target], main product-form-component:not([data-blaze-sticky-form])'
      )
    ).filter((target) => !root.contains(target));

    if (!('IntersectionObserver' in window) || targets.length === 0) {
      bar.classList.remove('is-hidden');
      return;
    }

    const visibleTargets = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visibleTargets.add(entry.target);
          else visibleTargets.delete(entry.target);
        });

        bar.classList.toggle('is-hidden', visibleTargets.size > 0);
      },
      { threshold: 0.18 }
    );

    targets.forEach((target) => observer.observe(target));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-blaze-sticky-root]').forEach(initStickyBuy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
